"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ua_parser_js_1 = require("ua-parser-js");
class Profile {
    constructor() {
        var _a;
        this.agent = new ua_parser_js_1.UAParser();
        this.muteByDefault = false;
        this.blacklisted = false;
        this.longPressForImageShare = false;
        this.iOS12HideSave = false;
        this.iOSFilesAppForPhotoShare = false;
        this.imageOnlyInShareData = false;
        this.os = (_a = this.agent.getOS().version) === null || _a === void 0 ? void 0 : _a.split('.');
        switch (this.agent.getBrowser().name) {
            case 'Mobile Safari':
                this._initMobileSafari();
                break;
            case 'Chrome':
                Profile._initChrome();
                break;
            case 'Safari':
                this._initSafari();
                break;
            default: break;
        }
    }
    static _initChrome() {
    }
    _initSafari() {
        this.muteByDefault = true;
    }
    _initMobileSafari() {
        var _a;
        this.muteByDefault = true;
        this.longPressForImageShare = true;
        this.imageOnlyInShareData = true;
        const versionParts = (_a = this.agent.getOS().version) === null || _a === void 0 ? void 0 : _a.split('.');
        if (versionParts && versionParts.length >= 2) {
            const majorVersion = parseInt(versionParts[0], 10);
            const minorVersion = parseInt(versionParts[1], 10);
            if (majorVersion < 11
                || (majorVersion === 11 && minorVersion < 3)) {
                this.blacklisted = true;
            }
            if (majorVersion === 12) {
                this.iOS12HideSave = true;
            }
            if (majorVersion >= 13) {
                this.longPressForImageShare = false;
                this.iOSFilesAppForPhotoShare = true;
            }
            if (majorVersion === 14) {
            }
        }
    }
}
exports.default = Profile;
//# sourceMappingURL=profile.js.map